export default {
    USER: '',
    LOGIN: '',
    LANG_FI: 'Finnish',
    LANG_EN: 'English',
    CHOOSE_LANG: 'Choose language',

    TOOLS: '',
    DASHBOARD: '',
    PICK: '',
    GROUPS: '',
    RANKING_LISTS: '',
    CHANGE_LOG: '',

    CHOOSE_FEED_CONTENT: '',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    HIDE: '',
    NEWS: '',
    STOCK_NEWS: '',
    PRESS_NEWS: '',
    RECENT_NEWS: '',
    SOCIAL_MEDIA: '',
    JOBS: '',
    COMPANY_EVENTS: '',
    APPOINTMENTS: 'Appointments',
    MODIFIED: 'modified',
    PUBLISHED: 'published',
    COMPANIES: 'companies',
    EMPTY: '',
    SEARCH: '',
    LATEST_STATEMENT: '',
    CONTENT_FOR_COMPANY_NOT_FOUND:
        'Company publications not found by the filters you chose.',

    // FRONT PAGE
    DEFAULT_COMPANY_FP: '',
    INDUSTRIES_FP: '',
    KEY_FIGURES_GRAPH_TITLE_FP: '',

    // INDUSTRY TAB
    CHOOSE_INDUSTRY: '',

    // LOGIN PAGE
    LOGIN_ACTION: '',
    USERNAME: '',
    PASSWORD: '',
    FORGOT_PASSWORD: '',
    NOT_USER_YET: '',
    ORDER_SERVICE: '',
    CONTACT: '',

    // COMPANY BASIC
    SOURCE: '',
    NAME: '',
    ROLE_IN_COMPANY: '',

    // COMPANY PAGE HEADER
    CONCERN_HEADER: 'Konserni',
    PARENT_HEADER: 'Emoyhtiö',

    // COMPANY PAGE RIGHT NAV
    BASIC_INFO: '',
    PERFORMER_RANKING: '',
    FINANCIAL_KEYS: '',
    REGISTRATIONS: '',
    COMPANY_ID_HISTORY: '',
    DECIDERS: '',
    MANAGEMENT_BOARD_AND_SOMETHING: '', // FIX THIS NAME
    CONCERN_COMPANIES: '',

    // COMPANY BASIC INFO
    GROWTH_AND_PROFITABILITY: '',
    GROWTH: '',
    PROFITABILITY: '',
    ACTIVE: '',
    COMPANY_SEARCH_PLACEHOLDER: '',
    COMPANY: '',
    DOWNLOAD_CONCERN_PDF: '',
    DOWNLOAD_PDF: '',
    DOWNLOAD_CONCERN_FINANCIAL_ANALYSIS_EXCEL: '',
    DOWNLOAD_FINANCIAL_ANALYSIS_EXCEL: '',
    DOWNLOAD_NOT_AVAILABLE: '',
    ADD_TO_GROUP: '',
    FINANCIAL_ANALYSIS: '',
    COMPANY_CONTACT_INFO: '',
    COMPANY_NAME_INFO: '',
    PRINCIPAL_COMPANY_NAMES: '',
    PARALLEL_COMPANY_NAMES: '',
    AUXILIARY_COMPANY_NAMES: '',
    PARALLEL_AUXILIARY_NAMES: '',
    // These codes are provided by the Arkki database
    CNT_1: '',
    CNT_2: '',
    CNT_3: '',
    CNT_4: '',
    COMPANY_NAME: '',
    COMPANY_ID: '',
    COMPANY_ID_GRANTED: '',
    INDUSTRY: '',
    INDUSTRY_DESCRIPTION: '',
    COMPANY_STATUS: '',
    COMPANY_DOMICILE: '',
    COMPANY_TYPE: '',
    COMPANY_LANGUAGE: '',
    CEO: '',

    STREET_ADDRESS: '',
    POST_ADDRESS: '',
    PHONE_NUMBER: '',
    WEB_ADDRESS: '',

    // BOARD AFFILIATIONS
    VALID_AFFILIATIONS: '',
    LAST_CHANGE_DATE: '',

    // COMPANY ID HISTORY
    DATE: '',
    EVENT: '',
    OLD_NAME: '',
    NEW_NAME: '',
    PREVIOUS_NAMES: '',
    TYPE: '',
    BEGUN: '',
    ENDED: '',

    // COMPANY STATUS
    COMPANY_STATUS_ACTIVE: '',
    COMPANY_STATUS_INACTIVE: '',
    COMPANY_STATUS_BANKRUPT: '',
    COMPANY_STATUS_LIQUIDATION: '',
    COMPANY_STATUS_REORGANIZATION: '',
    COMPANY_STATUS_PAUSED: '',
    COMPANY_STATUS_MISSING: '',
    COMPANY_STATUS_NO_STATEMENTS: '',

    // CONCERN COMPANIES
    CONCERN: '',
    DAUGHTER_COMPANIES_AND_LOCATIONS: '',

    // PROTESTS
    PROTESTS: '',
    DATE_OF_PROTEST: '',
    PROTEST_TYPE: '',
    NO_PROTESTS: '',

    // DECIDERS
    TITLE: '',
    RESPONSIBILITIES: '',
    CHECK_DATE: '',
    EMAIL: '',
    TELEPHONE: '',

    // FINANCIAL BASIC
    FINANCIAL_YEAR: '',
    TURNOVER: '',
    NET_PROFIT: '',
    EBIT: '',
    EBIT_PER_TURNOVER: '',
    EQUITY_RATIO: '',
    PERSONNEL: '',

    // COMPANY INFO KEY FIGURES
    TURNOVER_KF: '',
    TURNOVER_GROWTH_PERCENT_KF: '',
    NET_PROFIT_KF: '',
    AGGREGATE_EQUITY_KF: '',
    TOTAL_ASSETS_KF: '',
    PERSONNEL_AVERAGE_KF: '',
    NO_STATEMENT_HISTORY_KF: '',
    INDUSTRY_KF_TITLE: '',
    SAMPLE_SIZE: '',

    // KEY FIGURE GRAPHS
    KEY_FIGURES_GRAPH_TITLE: '',
    TURNOVER_GROWTH_PERCENT_GRAPH: '',
    RETURN_ON_INVESTMENT_GRAPH: '',
    NET_PROFIT_PER_TURNOVER_GRAPH: '',
    EQUITY_RATIO_GRAPH: '',
    CURRENT_RATIO_GRAPH: ' ',
    TURNOVER_GRAPH: '',
    NET_PROFIT_GRAPH: '',

    TURNOVER_GROWTH_PERCENT_EXPLANATION_GRAPH: '',
    RETURN_ON_INVESTMENT_EXPLANATION_GRAPH: '',
    NET_PROFIT_PER_TURNOVER_EXPLANATION_GRAPH: '',
    CURRENT_RATIO_EXPLANATION_GRAPH: '',
    EQUITY_RATIO_EXPLANATION_GRAPH: '',
    TURNOVER_EXPLANATION_GRAPH: '',
    NET_PROFIT_EXPLANATION_GRAPH: '',

    COMPARE: '',
    CHOOSE_COMPARE_COMPANY: '',
    SEARCH_COMPARE_COMPANY: '',
    COMPARE_NO_STATEMENTS: '',
    COMPARE_LATEST_STATEMENT: '',

    // COMPARE GRAPH MODAL
    COMPARE_GRAPH_MODAL_TITLE: '',
    CHOOSE_COMPARE_TARGET: '',
    CHOOSE_COMPANY: '',
    SEARCH_BY_NAME_OR_BUSINESS_ID: '',

    // MANAGEMENT BOARD
    DATE_OF_BIRTH: '',
    NATIONALITY: '',
    LAST_MODIFIED: '',
    BOARD: '',
    OTHER_MANAGEMENT: '',
    SIGNATORY_GROUP_MEMBERS: '',

    // PERFORMER RANKING
    NOTE_ON_PARENT_COMPANY: '',
    PERFORMER_RANKING_DESCRIPTION: '',
    PERFORMER_RANKING_POINTS_DESCRIPTION: '',
    PERFORMER_RANKING_HELP: '',
    PERFORMER_RANKING_HELP_LINK: '',
    RISK_CLASS: '',
    RISK_CLASS_DESCRIPTION: '',
    TRAFFIC_LIGHT_DESCRIPTION: '',
    NOT_AVAILABLE: '',

    // REGISTRATIONS
    REGISTER: '',
    BEGIN: '',
    END: '',
    COMPANY_ID_GRANTED_REGISTER: '',
    PREPAYMENT_REGISTER: '',
    PREPAYMENT_REGISTER_NEXT_REVISION: '',
    EMPLOYER_REGISTER: '',
    TAX_ADMINISTRATION_REGISTER: '',
    TRADE_REGISTER: '',
    VAT_REGISTER: '',
    VAT_REGISTER_DESCRIPTION: '',
    VAT_REGISTER_REAL_ESTATE_LIABILITY_DESCRIPTION: '',
    IN_REGISTER: '',
    NOT_IN_REGISTER: 'Ei rekisteröintiä',

    // GROUP PAGE
    CONFIRM_DELETE_BUSINESS: '',

    // FINANCIAL ANALYSIS
    KEYS: 'Tunnusluvut',
    INCOME_STATEMENT: 'Tuloslaskelma',
    BALANCE_ASSETS: 'Tase vastaavaa',
    BALANCE_LIABILITIES: 'Tase vastattavaa',
    CASH_FLOW_STATEMENT: 'Kassavirtalaskelma',

    // FINANCIAL ANALYSIS TABLE KEYS
    TABLE_KEYS: {
        keys: {
            statementLength: {
                statementLength: 'Tilikauden pituus (kk)'
            },
            scopeOfActivities: {
                title: 'Toiminnanlaajuus',
                turnover: 'Liikevaihto (€)',
                turnoverGrowthPercent: 'Liikevaihdon kasvuprosentti (%)',
                grossProfit: 'Bruttotulos (€)',
                growthInGrossProfitPercentage:
                    'Bruttotuloksen kasvuprosentti (%)',
                investmentExpensesCashFlow: 'Investoinnit (€)',
                totalAssets: 'Vastaavaa yhteensä (€)',
                personnelAverage: 'Henkilökunta keskimäärin (henk.)'
            },
            profitability: {
                title: 'Kannattavuus',
                ebitda: 'Käyttökate (€)',
                ebit: 'Liiketulos (€)',
                netProfitBeforeDepreciation: 'Rahoitustulos (€)',
                netProfit: 'Nettotulos (€)'
            },
            capitalAndRevenue: {
                title: 'Pääoma ja sen tuotto',
                turnoverRateOfCapital: 'Pääoman kiertonopeus (vuotta)',
                investedCapital: 'Sijoitettu pääoma (keskimäärin) (€)',
                interestBearingDebt: 'Korolliset velat (€)',
                bookValue: 'Tasesubstanssi (€)',
                calculusEva: 'Taloudellinen lisäarvo (EVA) (€)',
                calculusWacc: 'Painotettu pääoman kustannus (WACC) (%)',
                returnOnInvestmentPercent: 'Sijoitetun pääoman tuotto (%)',
                returnOnAssetsPercent: 'Koko pääoman tuotto (%)',
                returnOnEquityPercent: 'Oman pääoman tuotto (%)'
            },
            adequacyOfFunding: {
                title: 'Rahoituksen riittävyys',
                netInterestIncome: 'Korkokate (€)',
                netFinancialExpensesPerEbitda:
                    'Nettorahoituskulut / Käyttökate (%)',
                netFinancialExpensesPerOperatingIncomePercent:
                    'Nettorahoituskulut / liikevaihto (%)',
                liabilityPaybackTime:
                    'Vieraan pääoman takaisinmaksuaika (vuotta)'
            },
            rahoituksenrakenne: {
                title: 'Rahoituksen rakenne',
                equityRatio: 'Omavaraisuusaste (%)',
                gearing: 'Gearing (%)',
                debtEquityRatio: 'Velkaantumisaste (%)',
                netDebtEquityRatio: 'Nettovelkaantumisaste (%)',
                relativeIndebtedness: 'Suhteellinen velkaantuneisuus (%)',
                interestPerTurnoverPercent: 'Korkorasite (%)',
                interestPerInterestBearingDebt:
                    'Korkokulut / korolliset velat (%)'
            },
            workingCapitalAndRotationTimes: {
                title: 'Käyttöpääoma ja käyttöpääomien kiertoajat',
                workingCapital: 'Käyttöpääoma (€)',
                netWorkingCapital: 'Nettokäyttöpääoma (€)',
                salesReceivableTurnoverTime: 'Myyntisaamisten kiertoaika (vrk)',
                accountsPayableTurnoverTime: 'Ostovelkojen kiertoaika (vrk)',
                materialAndSupplyInventoryTurnoverTime:
                    'Ainevarastojen kiertoaika (vrk)',
                finishedGoodsInventoryTurnoverTime:
                    'Valmistevaraston kiertoaika (vrk)',
                currentAssetsTurnoverTime:
                    'Koko vaihto-omaisuuden kiertoaika (vrk)',
                currentAssetsPerTurnoverPercent:
                    'Vaihto-omaisuus / liikevaihto (%)'
            },
            liquidity: {
                title: 'Maksuvalmius',
                quickRatio: 'Quick ratio',
                currentRatio: 'Current ratio'
            },
            efficiencyKeyFigures: {
                title: 'Tehokkuustunnuslukuja',
                turnoverPerEmployee: 'Liikevaihto / henkilö (€)',
                valueAddedPerEmployee: 'Jalostusarvo / henkilö (€)',
                personnelExpensePerEmployee: 'Henkilöstökulut / henkilö (€)',
                ebitdaPerEmployee: 'Käyttökate / henkilö (€)',
                ebitPerEmployee: 'Liiketulos / henkilö (€)',
                netProfitPerEmployee: 'Nettotulos / henkilö (€)',
                valueAddedPerPersonnelExpense:
                    'Työn reaalituottavuus (jalostusarvo / palkat) (%)'
            },
            otherKeyFigures: {
                title: 'Muita tunnuslukuja',
                valueAddedPerTurnover: 'Jalostusarvo / liikevaihto (%)',
                exportPerTurnover: 'Vienti / liikevaihto (%)',
                performerRankingPoints: 'Menestyjäpisteet'
            }
        },
        profitAndLossAccount: {
            profitAndLossAccount: {
                title: 'Tuloslaskelma',
                turnover: 'Liikevaihto (€)',
                finishedGoodsIncrease: '+ Valmistevaraston lisäys (€)',
                otherOperatingIncome: '+ Liiketoiminnan muut tuotot (€)',
                associatedCompanyOperatingIncome:
                    '+ Osuus osakkuusyhtiöiden tuloksesta (€)',
                rawMaterialsUse: '– Ainekäyttö (€)',
                externalServices: '- Ulkopuoliset palvelut (€)',
                grossProfit: '– Bruttotulos (€)',
                personnelExpenses: '- Henkilöstökulut (€)',
                otherOperatingExpense: '- Liiketoiminnan muut kulut (€)',

                ebitda: 'Käyttökate (€)',
                adjustedDepreciation: '– Suunnitelman mukaiset poistot (€)',
                amortization: '– Arvonalentumiset (€)',

                ebit: 'Liiketulos (€)',
                dividendIncome: '+ Osinkotuotot (€)',
                otherInterestAndFinancialIncome:
                    '+ Muut korko- ja rahoitustuotot (€)',
                exchangeRateDifferenceEffects:
                    '+ Kirjatut valuuttakurssierot (€)',
                otherInterestAndFinancialExpense:
                    '- Korko- ja muut rahoituskulut (€)',
                depreciationInInvestments:
                    '– Sijoitusten ja arvopapereiden arvonalentumiset (€)',
                associatedCompanyFinancialTranches:
                    '+ Osuus osakkuusyhtiöiden tuloksesta (€)',
                directTaxes: '– Välittömät verot (€)',

                netProfit: 'Nettotulos (€)',
                extraordinaryIncome: '+ Satunnaiset tuotot (€)',
                extraordinaryExpense: '– Satunnaiset kulut (€)',
                extraordinaryAssociatedCompanyIncomeAndExpense:
                    '+ Satunnainen osakkuusyhtiötulos (€)',
                netGroupSupport: '– Konserniavustukset (€)',

                totalProfit: 'Kokonaistulos (€)',
                growthInUntaxedReserves: '– Vapaaehtoisten varausten kasvu (€)',
                depreciationDifference: '- Poistoerot (€)',
                otherAdjustmentItems: '– Muut oikaisuerät (€)',
                minorityShareFromProfit: '– Vähemmistön osuus tuloksesta (€)',

                bookResult: 'Kirjanpidon tulos (€)'
            }
        },
        balanceAssets: {
            fixedAssets: {
                title: 'Pysyvät vastaavat'
            },
            intangibleAssets: {
                title: 'Aineettomat hyödykkeet',
                startupAndResearchDevelopmentExpenses:
                    'Perustamis- ja tutkimusmenot (€)',
                goodwill: 'Liikearvot (€)',
                otherIntangibleAssets: 'Muut aineettomat hyödykkeet (€)',
                aggregateIntangibleAssets: 'Aineettomat hyödykkeet yhteensä (€)'
            },
            tangibleAssets: {
                title: 'Aineelliset hyödykkeet',
                landAndWaterProperty: 'Maa- ja vesialueet (€)',
                buildings: 'Rakennukset ja rakennelmat (€)',
                machineryAndEquipment: 'Koneet ja kalusto (€)',
                otherTangibleAssets: 'Muut aineelliset hyödykkeet (€)',
                advancePaymentsAndAcquisitionsInProcess:
                    'Keskeneräiset työt (€)',
                aggregateTangibleAssets: 'Aineelliset hyödykkeet yhteensä (€)'
            },
            longtermInvestments: {
                title: 'Pitkäaikaiset sijoitukset',
                stakesInGroupCompanies: 'Sisäiset osakkeet ja osuudet (€)',
                otherStakesAndShares: 'Muut osakkeet ja osuudet (€)',
                internalReceivables: 'Sisäiset saamiset (€)',
                otherReceivablesAndInvestments: 'Muut saamiset (€)',
                aggregateLongTermInvestments:
                    'Pitkäaikaiset sijoitukset yhteensä (€)',
                offBalanceSheetAssets: 'Taseen ulkopuoliset vastuut (€)',
                valuationItemsAndDepreciationDifference:
                    'Arvostuserät ja poistoero (€)'
            },
            currentAssets: {
                title: 'Vaihtuvat vastaavat'
            },
            stocks: {
                title: 'Vaihto-omaisuus',
                materialsAndSupplies: 'Aineet ja tarvikkeet (€)',
                incompleteProducts: 'Keskeneräiset tuotteet (€)',
                finishedGoods: 'Valmiit tuotteet / tavarat (€)',
                otherCurrentAssets: 'Muu vaihto-omaisuus (€)',
                aggregateCurrentAssets: 'Vaihto-omaisuus yhteensä (€)'
            },
            longtermReceivables: {
                title: 'Pitkäaikaiset saamiset',
                longTermSalesReceivable: 'Pitkäaikaiset myyntisaamiset (€)',
                longTermOutstandingLoans: 'Pitkäaikaiset lainasaamiset (€)',
                otherLongTermReceivables: 'Pitkäaikaiset muut saamiset (€)',
                aggregateLongTermReceivables:
                    'Pitkäaikaiset saamiset yhteensä (€)'
            },
            shorttermReceivables: {
                title: 'Lyhytaikaiset saamiset',
                shortTermSalesReceivable: 'Lyhytaikaiset myyntisaamiset (€)',
                adjustingEntriesAndAccruedIncome: 'Siirtosaamiset (€)',
                outstandingLoans: 'Lainasaamiset (€)',
                otherShortTermReceivables: 'Lyhytaikaiset muut saamiset (€)',
                aggregateShortTermReceivables:
                    'Lyhytaikaiset saamiset yhteensä (€)',

                financialAssetsAndSecurities:
                    'Rahoitusomaisuus arvopaperit (€)',
                cashAndCashEquivalents: 'Rahat ja pankkisaamiset (€)',
                totalAssets: 'Vastaavaa yhteensä (€)'
            }
        },
        balanceLiabilities: {
            capitalAndReserves: {
                title: 'Oma pääoma',
                shareCapital: 'Osakepääoma (€)',
                sharePremiumAccount: 'Ylikurssirahasto (€)',
                revaluationReserve: 'Arvonkorotusrahasto (€)',
                otherReserves: 'Muut rahastot (€)',
                otherRestrictedEquity: 'Muu sidottu oma pääoma (€)',
                resultFromPreviousFinancialYear:
                    'Edellisten tilikausien voitto / tappio (€)',
                bookResultInBalanceSheet: 'Tilikauden voitto / tappio (€)',
                aggregateEquity: 'Oma pääoma yhteensä (€)',

                equityConditionedLoan: 'Pääomalainat (€)',
                equityAdjustment: 'Oman pääoman oikaisu (€)',
                aggregateOtherEquityLikeItems:
                    'Muut pääoman luonteiset erät (€)'
            },
            accumulatedAppropriations: {
                title: 'Tilinpäätössiirtojen kertymä',

                accumulatedDepreciationDifference: 'Kertynyt poistoero (€)',
                aggregateUntaxedReserves: 'Vapaaehtoiset varaukset (€)',
                otherUnspecifiedAccumulatedFinancialStatementTransfers:
                    'Erittelemätön tilinpäätössiirtokertymä (€)',
                aggregateFinancialStatementTransfers:
                    'Tilinpäätössiirrot yhteensä (€)',
                mandatoryProvisionReserves: 'Pakolliset varaukset yhteensä (€)',
                offBalanceSheetLiabilities: 'Taseen ulkopuoliset vastuut (€)',
                deferredTaxLiabilities: 'Laskennallinen verovelka (€)'
            },
            creditors: {
                title: 'Vieras pääoma'
            },
            longtermLiabilities: {
                title: 'Pitkäaikaiset velat',
                bonds: 'Joukkovelkakirjalainat (€)',
                convertibleBonds: 'Vaihtovelkakirjalainat (€)',
                longTermLoansFromFinancialInstitutions:
                    'Pitkäaikaiset lainat rahoituslaitoksilta (€)',
                pensionLoans: 'Eläkelainat (€)',
                longTermReceivedAdvancePayments: 'Saadut ennakot (€)',
                longTermAccountsPayable: 'Pitkäaikaiset ostovelat (€)',
                otherLongTermLiabilities: 'Muut pitkäaikaiset velat (€)',
                aggregateLongTermLiabilities: 'Pitkäaikaiset velat yhteensä (€)'
            },
            shorttermLiabilities: {
                title: 'Lyhytaikaiset velat',
                shortTermLoansFromFinancialInstitutions:
                    'Lainat rahoituslaitoksilta (€)',
                shortTermPensionFunds: 'Lyhytaikaiset eläkelainat (€)',
                shortTermReceivedAdvancePayments:
                    'Tilauksista saadut ennakot (€)',
                shortTermAccountsPayable: 'Ostovelat (€)',
                shortTermAccruedLiabilities: 'Siirtovelat (€)',
                notesPayable: 'Rahoitusvekselit (€)',
                otherShortTermLiabilities: 'Muut lyhytaikaiset velat (€)',
                aggregateShortTermLiabilities:
                    'Lyhytaikaiset velat yhteensä (€)',
                totalAssetsAndLiabilities: 'Vastattavaa yhteensä (€)'
            }
        },
        cashFlowStatement: {
            cashFlowStatement: {
                title: 'Kassavirta',
                turnover: 'Liikevaihto (€)',
                growthInSalesReceivable: '- Myyntisaamisten kasvu (€)',
                growthInPercentageOfCompletionEntries:
                    '– Osatuloutussaamisten kasvu (€)',
                growthInReceivedAdvancePayments:
                    '+ Saatujen ennakkomaksujen kasvu (€)',

                cashIncomeOfSales: 'Myynnin kassatulot (€)',
                otherOperatingIncome: '+ Liiketoiminnan muut tuotot (€)',
                materialPurchases: '- Aineostot (€)',
                growthInAccountsPayable: '+ Ostovelkojen kasvu (€)',
                increaseInAdvancePayments: '– Ennakkomaksujen lisäys (€)',
                personnelExpenses: '– Henkilöstökulut (€)',
                externalServices: '- Ulkopuoliset palvelut (€)',
                aggregateOtherShortTermExpenses:
                    '– Muut lyhytvaikutteiset kulut yhteensä (€)',
                increaseInTransferringItems: '+ Siirtyvien erien lisäys (€)',
                increaseInMandatoryProvisionReserves:
                    '+ Pakollisten varausten lisäys (€)',
                manufacturingForOwnUseCashFlow:
                    '+ Valmistus omaan käyttöön (€)',

                cashFlowOperatingActivities: 'Toimintajäämä (€)',
                financialIncomeCashFlow: '+ Rahoitustuotot (€)',
                financialExpenseCashFlow: '– Rahoituskulut (€)',
                taxCashFlow: '– Verot (€)',
                dividendCashFlow: '– Osingot (€)',
                netGroupSupport: '+ Konserniavustukset (€)',
                netExtraordinaryIncomeCashFlow:
                    '+ Satunnaiset tuotot - kulut (€)',

                cashFlowOperatingAndFinancialActivities: 'Rahoitusjäämä (€)',
                investmentExpensesCashFlow: '- Investoinnit (€)',
                increaseInInvestmentsAndLongTermReceivablesCashFlow:
                    '– Sijoitusten ja pitkäaik. saamisten muutos (€)',
                unspecifiedInvestmentsCashFlow:
                    '– Erittelemättömät investoinnit (€)',

                cashFlowOperatingAndFinancialAndInvestmentActivities:
                    'Investointijäämä (€)',
                increaseInLongTermLiabilities:
                    '+ Pitkäaikaisen vieraan pääoman lisäys (€)',
                increaseInShortTermLiabilities:
                    '+ Lyhytaikaisen vieraan pääoman lisäys (€)',
                increaseInEquityConditionedLoans: '+ Pääomalainojen lisäys (€)',
                increaseInEquity: '+ Oman pääoman lisäys (€)',
                increaseInCashAssets: '+ Rahavarojen lisäys (€)',
                increaseInOtherShortTermReceivables:
                    '+ Muiden lyhytaikaisten saamisten lisäys (€)',
                adjustmentItemsCashFlow: '+ Oikaisuerät (€)',
                cashFlowStatementSmoothing: 'Kassalaskelman tasaus (€)'
            },
            keyFiguresBasedOnCashFlow: {
                title: 'Kassavirtapohjaisia lukuja',
                financialExpenseMargin: 'Rahoituskulujen hoitokate (€)',
                internalFinancingOfInvestments:
                    'Investointien tulorahoitus (€)',
                liabilityPaybackPeriod:
                    'Vieraan pääoman takaisinmaksuaika (kassavirta) (€)'
            }
        }
    },

    // ERROR
    LOGIN_ERROR_500: '',
    LOGIN_ERROR_401: '',
    LOGIN_ERROR_403: '',
    LOGIN_ERROR_EMPTY: '',
    API_ERROR_OCCURRED: 'While fetching data, an error occurred.',
    LOGIN_ERROR_PASSWORD_EXPIRED: 'Your password has expired',
    LOGIN_ERROR_UNDEFINED: '',

    // Links
    LINK_TO_ORIGINAL_NEWS_ITEM: 'Link to original article',

    APPOINTMENT_NEWS: 'Appointment news',
    COMPANIES_AFFILIATED_WITH_THE_PUBLICATION:
        'Companies affiliated with the publication',

    // VALIDATION
    BUSINESS_ID_NOT_VALID: '',
    ALREADY_ADDED_TO_GROUP: '',
    COMPANY_NOT_FOUND: '',

    // SEARCH PAGE
    SELECT: '',
    SEARCH_FROM_GROUP: '',
    COMPANY_BASIC_INFO: '',
    LOAD_EXCEL: '',
    OPEN_PREVIEW: '',
    PREVIEW: '',
    LOADING_EXCEL: '',
    CHOOSE_COMPANY_STATE: '',
    CHOOSE: '',
    ADDRESS_CITY: '',
    DOMICILE: '',
    DOMICILE_INFO: '',
    LOCATION_MUNICIPALITY: '',
    LOCATION_MUNICIPALITY_INFO: '',
    ONLY_NUMBERS_ALLOWED: '',
    LOWER_VALUE_GREATER_ERROR: '',
    FILL_BOTH_VALUES: '',
    VALUE_BEYOND_LIMITS: '',
    PERSONNEL_AVERAGE: '',
    PERSONNEL_EXPENSES: '',
    RAW_MATERIALS_USE: '',
    AGGREGATE_CURRENT_ASSETS: '',
    BUILDINGS: '',
    COMPANY_ID_GRANTED_START: '',
    COMPANY_ID_GRANTED_END: '',
    STARTDATE_AFTER_ENDDATE: '',
    FOCUS: '',
    PICK_INTRODUCTION: '',
    BUSINESS_IDS: '',
    SEARCH_NOTIFICATION_CREATING: '',
    SEARCH_NOTIFICATION_CREATING_DESCRIPTION: '',
    SEARCH_NOTIFICATION_MAX_ERROR: '',
    SEARCH_NOTIFICATION_SUCCESS: '',
    SEARCH_NOTIFICATION_SUCCESS_DESCRIPTION: '',
    SEARCH_NOTIFICATION_ERROR: '',

    // PICK POPOVERS
    PICK_INTRODUCTION_POPOVER: '',
    TURNOVER_POPOVER: '',
    EBIT_PER_TURNOVER_POPOVER: '',
    NET_PROFIT_POPOVER: '',
    PERSONNEL_AVERAGE_POPOVER: '',
    PERSONNEL_EXPENSES_POPOVER: '',
    RAW_MATERIALS_USE_POPOVER: '',
    AGGREGATE_CURRENT_ASSETS_POPOVER: '',
    BUILDINGS_POPOVER: '',

    // PICK TO GROUP
    PICK_TO_GROUP: '',
    PICK_READY: '',
    ADD_PICK_TO_GROUP: '',
    ADD_PICK_TO_NEW_GROUP: '',
    NEW_GROUP_NAME: '',
    NO_COMPANIES_TO_ADD: '',
    NOT_ALL_COMPANIES_WERE_ADDED: '',
    CANCEL: ''
};
